// Reusable ring/donut meter for a single percentage against a 0-100 limit
// (health scores, DNS-check pass rate, etc). Per the dataviz meter spec: the
// fill carries severity (good/warning/critical), the unfilled track is a
// lighter step of the SAME hue (not neutral gray) so state reads even where
// the ring isn't filled yet.
//
// Usage: <DonutMeter value={78} size={96} label="AVG HEALTH" />

const STATUS = { good: "#0ca30c", warning: "#fab219", critical: "#d03b3b" };

export function statusForScore(v) {
  if (v >= 80) return STATUS.good;
  if (v >= 60) return STATUS.warning;
  return STATUS.critical;
}

export default function DonutMeter({
  value = 0,
  size = 96,
  strokeWidth = 10,
  label = "",
  sublabel = "",
  color,
  trackOpacity = 0.16,
}) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  const fill = color || statusForScore(pct);
  const r = (size - strokeWidth) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - pct / 100);
  const hero = Math.max(14, Math.round(size * 0.24));

  return (
    <div
      role="img"
      aria-label={`${label ? label + ": " : ""}${pct}%`}
      title={`${label ? label + " — " : ""}${pct}%${sublabel ? " (" + sublabel + ")" : ""}`}
      style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 6 }}
    >
      <div style={{ position: "relative", width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }}>
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={fill} strokeOpacity={trackOpacity} strokeWidth={strokeWidth} />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset .5s ease, stroke .3s ease" }}
          />
        </svg>
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: hero,
            fontWeight: 700,
            color: fill,
            fontVariantNumeric: "proportional-nums",
          }}
        >
          {pct}%
        </div>
      </div>
      {(label || sublabel) && (
        <div style={{ textAlign: "center" }}>
          {label && (
            <p style={{ fontSize: 11, fontWeight: 600, color: "#605E5C", textTransform: "uppercase", letterSpacing: ".5px", margin: 0 }}>
              {label}
            </p>
          )}
          {sublabel && <p style={{ fontSize: 11, color: "#605E5C", margin: "2px 0 0" }}>{sublabel}</p>}
        </div>
      )}
    </div>
  );
}
